import { useAppSelector } from 'store/config';

function useLocale() {
  return useAppSelector(state => state.locale);
}

export default useLocale;
